import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { NotificationProvider } from "@/context/NotificationContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import Navbar from "@/components/Navbar";
import ProtectedRoute from "@/components/ProtectedRoute";
import HomePage from "@/pages/HomePage";
import QuizPage from "@/pages/QuizPage";
import ResultsPage from "@/pages/ResultsPage";
import ProductPage from "@/pages/ProductPage";
import BrowsePage from "@/pages/BrowsePage";
import StorePage from "@/pages/StorePage";
import PriceDropsPage from "@/pages/PriceDropsPage";
import ComparePage from "@/pages/ComparePage";
import WishlistPage from "@/pages/WishlistPage";
import AdminPage from "@/pages/AdminPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsOfServicePage from "@/pages/TermsOfServicePage";
import ContactPage from "@/pages/ContactPage";
import FinderPage from "@/pages/FinderPage";
import ProfilePage from "@/pages/ProfilePage";
import CookieConsent from "@/components/CookieConsent";
import Analytics from "@/components/Analytics";
import { LoginPage, RegisterPage, AuthCallback } from "@/pages/AuthPages";

function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id synchronously (prevents race conditions)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  // Hide navbar on auth pages, quiz, legal & contact
  const hideNavbar = ['/login', '/register', '/quiz', '/privacy', '/terms', '/contact'].includes(location.pathname) || location.pathname.startsWith('/auth/') || location.pathname.startsWith('/finder/');

  return (
    <>
      {!hideNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/quiz" element={<QuizPage />} />
        <Route path="/results/:profileId" element={<ResultsPage />} />
        <Route path="/finder/:slug" element={<FinderPage />} />
        <Route path="/shoe/:shoeId" element={<ProductPage />} />
        <Route path="/browse" element={<BrowsePage />} />
        <Route path="/store/:storeId" element={<StorePage />} />
        <Route path="/price-drops" element={<PriceDropsPage />} />
        <Route path="/compare" element={<ComparePage />} />
        <Route path="/wishlist" element={<ProtectedRoute><WishlistPage /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsOfServicePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
      </Routes>
      <CookieConsent />
      <Analytics />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <NotificationProvider>
          <CurrencyProvider>
            <AppRouter />
          </CurrencyProvider>
        </NotificationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
